export default __webpack_public_path__ + "static/media/스카우트.1b074da3.svg";